var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading || !_vm.hasFetched)?_c('Loading'):(_vm.error)?_c('div',{staticClass:"notification"},[_vm._v("ERROR: "+_vm._s(_vm.error.statusText))]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }